if (document.querySelector('.order__form-tabs')) {
  const orderFormTabsArr = document.querySelectorAll('.order__form-tab');
  orderFormTabsArr.forEach((tab) => {
    tab.addEventListener('click', () => {
      for (let i = 0; i < orderFormTabsArr.length; i++) {
        orderFormTabsArr[i].classList.remove('active');
      }
      tab.classList.add('active');
    });
  });
}

window.checkoutValidationsFunc = function checkoutValidationsFunc() {
  const requiredInputsContainersArr =
    document.querySelectorAll('.required-input');
  const orderButtons = document.querySelector('.order__cart-buttons');

  if (document.querySelector('.order__cart-buttons')) {
    function validateForm() {
      let allInputsValid = true;

      // console.log(requiredInputsContainersArr);

      requiredInputsContainersArr.forEach((requiredInputsContainer) => {
        const input = requiredInputsContainer.querySelector(
          'input:not(.choices__input)'
        );
        const select = requiredInputsContainer.querySelector('select');

        if (input) {
          const inputValue = input.value.trim();
          // console.log(input, `Input value: "${inputValue}"`);
          if (inputValue === '') {
            allInputsValid = false;
          }
        }

        if (select) {
          const selectValue = select.value.trim();
          // console.log(`Select value: "${selectValue}"`);
          if (selectValue === '') {
            allInputsValid = false;
          }
        }
      });

      if (allInputsValid) {
        orderButtons.classList.add('is-next-active');
        const btn = document.getElementById('checkout-btn');
        btn.disabled = false;
        btn.classList.remove('disabled-type');
      } else {
        orderButtons.classList.remove('is-next-active');
      }

      /*console.log('All inputs valid:', allInputsValid);*/
    }

    requiredInputsContainersArr.forEach((requiredInputsContainer) => {
      if (!requiredInputsContainer.classList.contains('is-valid-start')) {
        requiredInputsContainer.classList.add('is-valid-start');

        const input = requiredInputsContainer.querySelector('input');
        const select = requiredInputsContainer.querySelector('select');

        if (input) {
          input.addEventListener('input', () => {
            validateForm();

            if (!orderButtons.classList.contains('is-next-active')) {
              enableCheckoutBtn();
            }
          });
        }

        if (select) {
          select.addEventListener('change', () => {
            validateForm();

            if (!orderButtons.classList.contains('is-next-active')) {
              enableCheckoutBtn();
            }
          });
        }
      }
    });

    validateForm();
  }
};

checkoutValidationsFunc();

const otherNovaInput = document.querySelector('#other_address');
if(otherNovaInput) {
  const profileNameInput = document.querySelector('[name="full_name"]');
  const emailInput = document.querySelector('[name="email"]');
  const telInput = document.querySelector('[name="tel"]');

  const orderButtons = document.querySelector('.order__cart-buttons');

  otherNovaInput.addEventListener('input', () => {
    if(otherNovaInput.value !== '' && profileNameInput.value !== '' && emailInput.value !== '' && telInput.value !== '') {
      enableCheckoutBtn();
      orderButtons.classList.add('is-next-active');
    } else {
      disableCheckoutBtn();
      orderButtons.classList.remove('is-next-active');
    }
  })
}
